import { render, staticRenderFns } from "./TServRedirectComp.vue?vue&type=template&id=8190e4aa&"
import script from "./TServRedirectComp.vue?vue&type=script&lang=js&"
export * from "./TServRedirectComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports